import { getUserToken, subscribeToUserToken } from '@lumapps/base-api/user-token';

import { actions } from './slice';

interface TokenSyncStore {
    dispatch: (action: any) => void;
}

/**
 * Mirrors the user JWT from the `@lumapps/base-api` token store into `user.connectedUser.token`.
 *
 * The token store is the source of truth. This copy exists only for `lumapps-sdk-js`, which builds
 * `useCurrentUser().token` from a redux selector on `user.connectedUser.token` and hands it to
 * extensions, which put it in their `Authorization` header. Without this sync every extension that
 * calls the API sends `Bearer undefined`.
 *
 * Call it once per store, right after the store is created.
 *
 * @param store - the redux store to keep in sync
 * @returns the unsubscribe function
 */
export const syncConnectedUserToken = (store: TokenSyncStore) => {
    store.dispatch(actions.setConnectedUserToken(getUserToken()));

    return subscribeToUserToken((token) => {
        store.dispatch(actions.setConnectedUserToken(token));
    });
};
